module.exports = __webpack_public_path__ + "static/img/badge-landing-rate-inactive.7e1b4f1.svg";